<template>
  <div>
    <div class="aiDialog">
      <el-upload
        ref="elUpload"
        class="upload-demo"
        :action="url"
        :headers="{ token: uploadToken }"
        drag
        :limit="1"
        name="fileStream"
        accept=".xlsx"
        :data="uploadParam"
        :with-credentials="true"
        :on-remove="(file, fileList) => handleRemoveImg(file, fileList)"
        :before-upload="(file, size) => uploadCheck(file)"
        :on-success="(res, file, fileList) => handleUploadImg(res, file, fileList)"
        :on-exceed="onExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将采购清单拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
    </div>
    <div class="aiDialog-text">
      1.按照模板导入：
      <el-link type="primary" href="https://static.kminghealth.com/upload/templates/采购清单模板.xlsx" target="_blank">
        <i class="el-icon-link"></i>
        采购清单模板.xlsx
      </el-link>
      ，点击下载
    </div>
  </div>
</template>
<script>
import config from '@/const/config';
const baseUrl = config.uploadBaseUrl;
export default {
  data() {
    return {
      uploadToken: localStorage.getItem('_token'),
      url: baseUrl + '/api/file/1.0/h5_upload',
      uploadParam: {
        uploadParam: JSON.stringify({
          scene: 'excel_file',
          appName: 'share-mall-gateway'
        })
      },
      size: 5
    };
    paramsFile: null;
  },
  methods: {
    onExceed(files, fileList) {
      this.$message.warning(`无法再次上传，最多只能上传一个文件`);
    },
    clear() {
      const { elUpload } = this.$refs;
      this.paramsFile = null;
      elUpload.clearFiles();
      this.$emit('change');
    },
    handleRemoveImg() {
      this.paramsFile = null;
      this.$emit('change');
    },
    uploadCheck(file) {
      const { size } = this;
      const imgSize = file.size / 1024 / 1024;
      if (imgSize > size) {
        this.$message.warning(`上传文件不能超过${size}M`);
        return false;
      }
      return true;
    },
    handleUploadImg(res, file, fileList) {
      if (res?.result?.code !== 'NO_ERROR') {
        this.$message.error('文件上传失败，请重试');
        this.paramsFile = null;
        this.$emit('change');
        return;
      }

      this.paramsFile = {
        url: file.response.result.data.url,
        fileId: file.response.result.data.resId
      };
      this.$emit('change');
    },
    getFile() {
      return this.paramsFile;
    }
  }
};
</script>
